// Frog Window Cleaning — theme JS

(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		initMobileNavToggle();
		initSubmenuToggles();
		initPricingQuotes();
	});

	// ------------------------------------------------------------------
	// Mobile nav toggle (burger button)
	// ------------------------------------------------------------------
	function initMobileNavToggle() {
		var toggle = document.querySelector('.site-header__toggle');
		var nav    = document.getElementById('site-nav');
		if (!toggle || !nav) return;

		toggle.addEventListener('click', function () {
			var open = nav.classList.toggle('is-open');
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		});

		// Close mobile nav when a normal link is tapped (but not the chevron).
		nav.addEventListener('click', function (e) {
			if (
				e.target.tagName === 'A' &&
				!e.target.classList.contains('sub-toggle') &&
				nav.classList.contains('is-open')
			) {
				nav.classList.remove('is-open');
				toggle.setAttribute('aria-expanded', 'false');
			}
		});
	}

	// ------------------------------------------------------------------
	// Submenu toggles — inject a chevron button next to every parent
	// link, wire ARIA, hover (desktop) + click (touch / mobile),
	// outside-click + Escape close.
	// ------------------------------------------------------------------
	function initSubmenuToggles() {
		var parents = document.querySelectorAll('.site-header__menu .menu-item-has-children');
		if (!parents.length) return;

		var chevronSVG =
			'<svg viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
			'<path d="M2.5 4.5l3.5 3.5 3.5-3.5" stroke="currentColor" stroke-width="1.8" ' +
			'stroke-linecap="round" stroke-linejoin="round"/>' +
			'</svg>';

		parents.forEach(function (parent, index) {
			var link    = parent.querySelector(':scope > a');
			var submenu = parent.querySelector(':scope > .sub-menu');
			if (!link || !submenu) return;

			// Give the submenu an id so the toggle can reference it.
			if (!submenu.id) submenu.id = 'sub-menu-' + (index + 1);

			// Build the chevron toggle button.
			var btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'sub-toggle';
			btn.setAttribute('aria-expanded', 'false');
			btn.setAttribute('aria-controls', submenu.id);
			btn.setAttribute('aria-label', 'Toggle ' + (link.textContent || '').trim() + ' submenu');
			btn.innerHTML = chevronSVG;

			link.insertAdjacentElement('afterend', btn);

			btn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				toggleParent(parent, btn);
			});
		});

		// Close all open submenus when clicking outside the header.
		document.addEventListener('click', function (e) {
			if (!e.target.closest('.site-header__menu')) closeAll();
		});

		// Escape closes any open submenu and returns focus to the trigger.
		document.addEventListener('keydown', function (e) {
			if (e.key !== 'Escape') return;
			var open = document.querySelector('.site-header__menu .menu-item-has-children.is-open');
			if (!open) return;
			var trigger = open.querySelector(':scope > .sub-toggle');
			closeAll();
			if (trigger) trigger.focus();
		});

		function toggleParent(parent, btn) {
			var open = parent.classList.toggle('is-open');
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');

			// Close sibling submenus at the same level.
			if (open) {
				var siblings = parent.parentElement.children;
				for (var i = 0; i < siblings.length; i++) {
					if (siblings[i] !== parent) {
						siblings[i].classList.remove('is-open');
						var siblingBtn = siblings[i].querySelector(':scope > .sub-toggle');
						if (siblingBtn) siblingBtn.setAttribute('aria-expanded', 'false');
					}
				}
			}
		}

		function closeAll() {
			document.querySelectorAll('.site-header__menu .menu-item-has-children.is-open').forEach(function (p) {
				p.classList.remove('is-open');
				var b = p.querySelector(':scope > .sub-toggle');
				if (b) b.setAttribute('aria-expanded', 'false');
			});
		}
	}

	// ------------------------------------------------------------------
	// Pricing Quote — multi-step builder.
	//
	// Step 1: recurring plan (property × frequency × add-ons + live total)
	// Step 2: one-off services (skippable)
	// Step 3: Gravity Form for contact details, with hidden quote fields
	//         pre-populated from the user's selections.
	//
	// Attaches to every [data-pq] panel. Multiple instances on a page are safe.
	// ------------------------------------------------------------------
	function initPricingQuotes() {
		document.querySelectorAll('[data-pq]').forEach(function (root) {
			var dataEl = root.querySelector('[data-pq-houses]');
			if (!dataEl) return;
			var houses;
			try { houses = JSON.parse(dataEl.textContent); } catch (e) { return; }

			// ---- Refs --------------------------------------------------
			var totalEl    = root.querySelector('[data-pq-total]');
			var sublineEl  = root.querySelector('[data-pq-subline]');
			var oneoffEl   = root.querySelector('[data-pq-oneoff-total]');
			var oneoffRow  = root.querySelector('[data-pq-oneoff-total-row]');

			// Summary refs (steps 2 + 3)
			var sumPlan        = root.querySelector('[data-pq-summary-plan]');
			var sumRecurring   = root.querySelector('[data-pq-summary-recurring]');
			var sumRecurring2  = root.querySelector('[data-pq-summary-recurring-2]');
			var sumHouse       = root.querySelector('[data-pq-summary-house]');
			var sumFreq        = root.querySelector('[data-pq-summary-freq]');
			var sumExtras      = root.querySelector('[data-pq-summary-extras]');
			var sumExtrasRow   = root.querySelector('[data-pq-summary-extras-row]');
			var sumOneoff      = root.querySelector('[data-pq-summary-oneoff]');
			var sumOneoffRow   = root.querySelector('[data-pq-summary-oneoff-row]');

			// ---- Helpers ----------------------------------------------
			function findHouse(key) {
				for (var i = 0; i < houses.length; i++) if (houses[i].key === key) return houses[i];
				return houses[0];
			}

			function setText(el, value) { if (el) el.textContent = value; }

			// ---- Recalculate -------------------------------------------
			// Returns the current state object so other handlers (form
			// population, step navigation) can use the same source of truth.
			function recalc() {
				var houseInput = root.querySelector('input[name="pq-house"]:checked');
				var freqInput  = root.querySelector('input[name="pq-freq"]:checked');
				var house      = findHouse(houseInput ? houseInput.value : '');
				var freq       = freqInput ? freqInput.value : '6';

				// Frequency label (e.g. "Every 6 weeks") — pulled from the radio's adjacent label DOM.
				var freqLabel = '';
				if (freqInput) {
					var lbl = freqInput.closest('label');
					var t   = lbl && lbl.querySelector('.pq-option__label');
					freqLabel = t ? t.textContent.trim() : 'every ' + freq + ' weeks';
				}

				var priceKey = 'price_' + freq;
				var base     = parseFloat(house[priceKey] != null ? house[priceKey] : house.price_6) || 0;

				// Recurring extras
				var extras = 0;
				var pickedExtras = [];   // [{key, label, qty, price, total}]
				root.querySelectorAll('[data-pq-ex]').forEach(function (el) {
					var p = parseFloat(el.dataset.pqPrice) || 0;
					var label = el.dataset.pqLabel || el.dataset.pqEx;
					if (el.type === 'checkbox' && el.checked) {
						extras += p;
						pickedExtras.push({ key: el.dataset.pqEx, label: label, qty: 1, price: p, total: p });
					} else if (el.hasAttribute('data-pq-qty')) {
						var q = parseInt(el.value, 10) || 0;
						if (q > 0) {
							extras += p * q;
							pickedExtras.push({ key: el.dataset.pqEx, label: label, qty: q, price: p, total: p * q });
						}
					}
				});

				// One-off services
				var oneoff = 0;
				var pickedOneoffs = [];   // [{key, label, group, price}]
				root.querySelectorAll('[data-pq-oneoff]').forEach(function (el) {
					if (el.checked) {
						var p = parseFloat(el.dataset.pqPrice) || 0;
						oneoff += p;
						pickedOneoffs.push({
							key: el.dataset.pqOneoff,
							label: el.dataset.pqLabel || el.dataset.pqOneoff,
							group: el.dataset.pqGroup || '',
							price: p
						});
					}
				});

				var recurringTotal = base + extras;

				// Update step 1 total bar
				setText(totalEl, recurringTotal.toFixed(0));
				setText(sublineEl, house.label + ' \u00b7 ' + freqLabel.toLowerCase());

				// Step 2 oneoff running total
				setText(oneoffEl, oneoff.toFixed(0));
				if (oneoffRow) oneoffRow.hidden = oneoff === 0;

				// Step 2 compact summary
				setText(sumPlan, house.label + ' \u00b7 ' + freqLabel.toLowerCase());
				setText(sumRecurring, recurringTotal.toFixed(0));

				// Step 3 detailed summary
				setText(sumHouse, house.label);
				setText(sumFreq, freqLabel);
				if (sumExtras && sumExtrasRow) {
					if (pickedExtras.length) {
						sumExtras.textContent = pickedExtras.map(function (e) {
							return e.qty > 1 ? e.label + ' (\u00d7' + e.qty + ')' : e.label;
						}).join(', ');
						sumExtrasRow.hidden = false;
					} else {
						sumExtrasRow.hidden = true;
					}
				}
				setText(sumRecurring2, recurringTotal.toFixed(0));
				if (sumOneoff && sumOneoffRow) {
					setText(sumOneoff, oneoff.toFixed(0));
					sumOneoffRow.hidden = oneoff === 0;
				}

				return {
					house: house,
					freq: freq,
					freqLabel: freqLabel,
					base: base,
					extras: pickedExtras,
					extrasTotal: extras,
					recurringTotal: recurringTotal,
					oneoffs: pickedOneoffs,
					oneoffTotal: oneoff
				};
			}

			// ---- Step navigation ---------------------------------------
			var screens   = root.querySelectorAll('[data-pq-step]');
			var progress  = root.querySelectorAll('[data-pq-progress]');
			var current   = 1;

			function showStep(n) {
				current = n;
				screens.forEach(function (s) {
					s.hidden = parseInt(s.dataset.pqStep, 10) !== n;
				});
				progress.forEach(function (p) {
					var pn = parseInt(p.dataset.pqProgress, 10);
					p.classList.toggle('is-current', pn === n);
					p.classList.toggle('is-done',    pn < n);
				});

				// Refresh state + populate form when entering step 3.
				var state = recalc();
				if (n === 3) populateForm(state);

				// Scroll the panel into view (top-aligned with a small offset).
				try {
					var panel = root.getBoundingClientRect();
					var top   = window.scrollY + panel.top - 24;
					window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
				} catch (e) { /* no-op */ }
			}

			// Continue / back buttons.
			root.querySelectorAll('[data-pq-next]').forEach(function (btn) {
				btn.addEventListener('click', function (e) {
					e.preventDefault();
					var n = parseInt(btn.dataset.pqNext, 10);
					if (n) showStep(n);
				});
			});
			root.querySelectorAll('[data-pq-prev]').forEach(function (btn) {
				btn.addEventListener('click', function (e) {
					e.preventDefault();
					var n = parseInt(btn.dataset.pqPrev, 10);
					if (n) showStep(n);
				});
			});

			// Skip — clear all one-offs first, then advance.
			var skipBtn = root.querySelector('[data-pq-skip]');
			if (skipBtn) {
				skipBtn.addEventListener('click', function (e) {
					e.preventDefault();
					root.querySelectorAll('[data-pq-oneoff]:checked').forEach(function (el) { el.checked = false; });
					recalc();
					showStep(3);
				});
			}

			// ---- Stepper +/- buttons ----------------------------------
			root.querySelectorAll('.pq-extra__stepper').forEach(function (stepper) {
				var input = stepper.querySelector('input');
				if (!input) return;
				var max = parseInt(input.getAttribute('max'), 10) || 99;

				stepper.querySelectorAll('[data-pq-inc]').forEach(function (btn) {
					btn.addEventListener('click', function () {
						input.value = Math.min(max, (parseInt(input.value, 10) || 0) + 1);
						recalc();
					});
				});
				stepper.querySelectorAll('[data-pq-dec]').forEach(function (btn) {
					btn.addEventListener('click', function () {
						input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
						recalc();
					});
				});
			});

			// ---- Recalc on any input change ---------------------------
			root.querySelectorAll('input').forEach(function (el) {
				el.addEventListener('change', recalc);
				el.addEventListener('input', recalc);
			});

			// ---- Gravity Form populator -------------------------------
			// Looks for inputs in the form whose name starts with 'input_'
			// (Gravity Forms convention) and whose wrapper has a CSS class
			// matching one of our `pq-fill--*` hooks. The frog-quote-form.json
			// import wires those hooks up.
			function populateForm(state) {
				var formWrap = root.querySelector('.pq-form-wrap');
				if (!formWrap) return;

				function setByHook(hook, value) {
					formWrap.querySelectorAll('.gfield.' + hook + ' input, .gfield.' + hook + ' textarea').forEach(function (el) {
						el.value = value;
					});
				}

				setByHook('pq-fill--house',      state.house.key);
				setByHook('pq-fill--house-label',state.house.label);
				setByHook('pq-fill--freq',       state.freq);
				setByHook('pq-fill--freq-label', state.freqLabel);
				setByHook('pq-fill--recurring',  '\u00a3' + state.recurringTotal.toFixed(0) + ' / visit');
				setByHook('pq-fill--oneoff-total','\u00a3' + state.oneoffTotal.toFixed(0));

				var extrasText = state.extras.length
					? state.extras.map(function (e) {
						return (e.qty > 1 ? e.label + ' x' + e.qty : e.label) + ' (\u00a3' + e.total.toFixed(0) + ')';
					}).join('\n')
					: '— none —';
				setByHook('pq-fill--extras', extrasText);

				var oneoffText = state.oneoffs.length
					? state.oneoffs.map(function (o) {
						return (o.group ? o.group + ': ' : '') + o.label + ' (\u00a3' + o.price.toFixed(0) + ')';
					}).join('\n')
					: '— none —';
				setByHook('pq-fill--oneoffs', oneoffText);

				// Trigger Gravity Forms' field-changed event so any conditional logic
				// or live validation re-runs against the freshly written values.
				if (window.jQuery && window.jQuery.fn) {
					formWrap.querySelectorAll('.gfield input, .gfield textarea').forEach(function (el) {
						try { window.jQuery(el).trigger('change'); } catch (e) { /* no-op */ }
					});
				}
			}

			// ---- Init -------------------------------------------------
			recalc();
		});
	}
})();
